export default {
  topMenu: {
    'openSettings': 'Beállítások megnyitása',
    'showAbout': 'Általános információk',
    'about': 'Az ORS névjegye',
    'pinSidebar': 'Oldalsáv rögzítése',
    'settingsTooltip': 'Kattintson ide, ha szeretné módosítani az alkalmazás beállításait'
  }
}
